import { jwtDecode } from "jwt-decode";
import { resolveSessionUserId } from "../helpers/authUserId";
import { readStoredAccessToken } from "../helpers/authToken";
import { pickManagedClubIdFromJwtPayload } from "../helpers/managedClubId";
import Constant from "../util/constant";

const readStoredManagedClubId = () => {
  const raw = window.localStorage.getItem(
    Constant.LOCALSTORAGEKEYS.MANAGED_CLUB_ID
  );
  return raw != null && raw !== "" && raw !== "undefined"
    ? String(raw)
    : null;
};

const useAuth = () => {
  const token = readStoredAccessToken();
  let isOrganiser = false;
  let isAdmin = false;
  let isClubManager = false;
  let isClubEmployee = false;
  let managedClubId = null;
  let userId = null;
  let auth = null;

  if (token) {
    try {
      const decoded = jwtDecode(token);

      const { role } = decoded;

      isOrganiser = role === Constant.ROLES.ORGANISER;
      isAdmin = role === Constant.ROLES.ADMIN;
      isClubManager = role === Constant.ROLES.CLUB_MANAGER;
      isClubEmployee = role === Constant.ROLES.CLUB_EMPLOYEE;
      userId = resolveSessionUserId(decoded);
      auth = token;

      managedClubId = pickManagedClubIdFromJwtPayload(decoded);

      if (!managedClubId) {
        managedClubId = readStoredManagedClubId();
      }

      return {
        userId,
        isOrganiser,
        isAdmin,
        isClubManager,
        isClubEmployee,
        isClubStaff: isClubManager || isClubEmployee,
        managedClubId,
        auth,
      };
    } catch {
      /* fall through — invalid token in storage */
    }
  }

  managedClubId = readStoredManagedClubId();

  return {
    userId,
    isOrganiser,
    isAdmin,
    isClubManager,
    isClubEmployee,
    isClubStaff: false,
    managedClubId,
    auth,
  };
};
export default useAuth;
